import React from "react";
import {TextStyled} from "@nike/nike-design-system-components";


const ContentModalError= (): JSX.Element => {
    return (
        <TextStyled >
           An error occurred while processing request. Please try again after some time.
        </TextStyled>
    );
};

export default ContentModalError
